import { ICONS } from 'Components/utils/icon/icons';

export const themes = {
  default: () => {
    return {
      thCollapse: 'mt-20 px-15 py-10 shadow-sm rounded-4',
      thCollapseTheme: 'homeDetails',
      thCollapseIconCollapse: ICONS.ARROW_DOWN,
      thCollapseIconExpand: ICONS.ARROW_DOWN,
    };
  },
};
